import Profile from "../panel/user/Profile.jsx";

import SupportDashboardHome from "./Dashboard.jsx";
import ConsultationList from "../AdminPanel/ConsultationList.jsx";
import ConsultationDetail from "../AdminPanel/ConsultationDetail.jsx";
import ManagerTicketList from "../AdminPanel/ManagerTicketList.jsx";
import ManagerTicketDetail from "../AdminPanel/ManagerTicketDetail.jsx";
import ManageShops from "../panel/user/ManageShops.jsx";
import EditShopPages from "../panel/user/manageShop/EditShopPages.jsx";
import EditShopInfo from "../panel/user/manageShop/EditShopInfo.jsx";
import EditShopProducts from "../panel/user/manageShop/EditShopProducts.jsx";
import AddShopProductPage from "../panel/user/AddShopProductPage.jsx";
import EditShopProductPage from "../panel/user/EditShopProductPage.jsx";
import EditShopCategories from "../panel/user/manageShop/EditShopCategories.jsx";
import EditShopShowcase from "../panel/user/manageShop/EditShopShowcase";
import ManageShopDetail from "../panel/user/ManageShopDetail.jsx";

import ShopCardInfo from "../panel/user/manageShop/ShopCardInfo.jsx";
import ShopTrustSeal from "../panel/user/manageShop/ShopTrustSeal.jsx";
import RegisterSiteForm from "../panel/user/RegisterSiteForm.jsx";

// نگاشت id هر آیتم منو به کامپوننت صفحه‌ی مربوطه
// این همون idهایی هستن که در NAV_DATA داخل Sidebar.jsx استفاده شده‌اند
export const PAGE_ROUTES = [
  { id: "dashboard", Component: SupportDashboardHome },
  { id: "profile", Component: Profile },

  {
    id: "ticket-management",
    Component: ManagerTicketList,
    children: [{ path: ":ticketId", Component: ManagerTicketDetail }],
  },
  {
    id: "consultation",
    Component: ConsultationList,
    children: [{ path: ":consultationId", Component: ConsultationDetail }],
  },
  {
    id: "manage-shops",
    Component: ManageShops,
    children: [
      { path: ":shopId", Component: ManageShopDetail },
      { path: ":shopId/pages", Component: EditShopPages },
      { path: ":shopId/info", Component: EditShopInfo },
      { path: ":shopId/products", Component: EditShopProducts },
      { path: ":shopId/products/add", Component: AddShopProductPage },
      {
        path: ":shopId/products/edit/:productId",
        Component: EditShopProductPage,
      },
      { path: ":shopId/category", Component: EditShopCategories },
      { path: ":shopId/showcase", Component: EditShopShowcase },
      { path: ":shopId/card", Component: ShopCardInfo },
      { path: ":shopId/trust", Component: ShopTrustSeal },
    ],
  },
  { id: "register-site", Component: RegisterSiteForm },
];

// برای سازگاری با کدهای قدیمی که هنوز از PAGE_COMPONENTS استفاده می‌کنن
// (مثلاً اگه جای دیگه‌ای از پروژه بهش رفرنس داده شده)
export const PAGE_COMPONENTS = Object.fromEntries(
  PAGE_ROUTES.map(({ id, Component }) => [id, Component]),
);
